const ApplicationLogo = (props) => {
    return <img {...props} src={'/images/logo-selectme.png'} alt={'Mistsubishi Electric Select Me 2.0'} />;
};
export default ApplicationLogo;
